// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "ITC Novarese W04 Bold";
    src: url("https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.eot");
    src: url("https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.eot?#iefix")format("embedded-opentype"),
    url("https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.woff2")format("woff2"),
    url("https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.woff")format("woff"),
    url("https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.ttf")format("truetype"),
    url("https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.svg#ITC Novarese W04 Bold")format("svg");
}

body {
    font-family: Helvetica, Arial, sans-serif
}

h1 {
    background-color: #0c194b;
    color: white;
    padding: 5px;
    font-family: "ITC Novarese W04 Bold";
    text-align: center;
}

h1.title {
    background-color: #0c194b;
    color: white;
    /* font-family: "ITC Novarese W04 Bold"; */
    text-align: center;
    
    margin: 0;
}

svg {
    border-width: 1px;
    border-style: solid;
    border-color: black;
    margin: 0 ;
}

/* div.tooltip {
    position: absolute;
    text-align: center;
    width: 60px;
    height: 28px;
    padding: 2px;
    font: 12px sans-serif;
    background: rgb(243, 239, 22);
    border: 0px;
    border-radius: 8px;
    pointer-events: none;
  } */

  .tooltip {
    background-color: #333;
    color: #fff;
    border-radius: 5px;
    padding: 10px;
    position: absolute;
    z-index: 1;
  }
  
  /* .tooltip-content { */
    /* Add additional styling for the content */
  /* } */

.mainView {
    display: flex;
    
    /* justify-content: center;
    align-items: center; */
}

`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,gFAAgF;IAChF;;;;kHAI8G;AAClH;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;;IAElB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;;;;;;;;;;;KAWK;;EAEH;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,UAAU;EACZ;;EAEA,uBAAuB;IACrB,2CAA2C;EAC7C,MAAM;;AAER;IACI,aAAa;;IAEb;0BACsB;AAC1B","sourcesContent":["@font-face {\n    font-family: \"ITC Novarese W04 Bold\";\n    src: url(\"https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.eot\");\n    src: url(\"https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.eot?#iefix\")format(\"embedded-opentype\"),\n    url(\"https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.woff2\")format(\"woff2\"),\n    url(\"https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.woff\")format(\"woff\"),\n    url(\"https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.ttf\")format(\"truetype\"),\n    url(\"https://db.onlinewebfonts.com/t/4035f05690d57781a7dad59bcf5c5818.svg#ITC Novarese W04 Bold\")format(\"svg\");\n}\n\nbody {\n    font-family: Helvetica, Arial, sans-serif\n}\n\nh1 {\n    background-color: #0c194b;\n    color: white;\n    padding: 5px;\n    font-family: \"ITC Novarese W04 Bold\";\n    text-align: center;\n}\n\nh1.title {\n    background-color: #0c194b;\n    color: white;\n    /* font-family: \"ITC Novarese W04 Bold\"; */\n    text-align: center;\n    \n    margin: 0;\n}\n\nsvg {\n    border-width: 1px;\n    border-style: solid;\n    border-color: black;\n    margin: 0 ;\n}\n\n/* div.tooltip {\n    position: absolute;\n    text-align: center;\n    width: 60px;\n    height: 28px;\n    padding: 2px;\n    font: 12px sans-serif;\n    background: rgb(243, 239, 22);\n    border: 0px;\n    border-radius: 8px;\n    pointer-events: none;\n  } */\n\n  .tooltip {\n    background-color: #333;\n    color: #fff;\n    border-radius: 5px;\n    padding: 10px;\n    position: absolute;\n    z-index: 1;\n  }\n  \n  /* .tooltip-content { */\n    /* Add additional styling for the content */\n  /* } */\n\n.mainView {\n    display: flex;\n    \n    /* justify-content: center;\n    align-items: center; */\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
